import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-app p-6">
      <div className="max-w-md w-full card-surface shadow rounded-lg p-8 text-center">
        <h1 className="text-6xl font-bold text-theme">404</h1>
        <p className="mt-2 text-xl text-theme opacity-80">Page Not Found</p>
        <p className="mt-4 text-sm text-theme opacity-70">
          The page you’re looking for doesn’t exist or has been moved.
        </p>
        <button
          onClick={() => navigate("/")}
          className="mt-6 inline-flex items-center px-3 py-1.5 btn-theme rounded text-xs hover:opacity-95 transition-opacity"
        >
          Go to Homepage
        </button>
      </div>
    </div>
  );
};

export default NotFound;
